import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { AppProvider } from './AppContext';
import Home from './pages/Home';
import Category from './pages/Category';
import Items from './pages/Items';
import QrPage from './pages/QrPage';
import AdminPage from './pages/AdminPage';
import PrintPage from './pages/PrintPage';

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <AppProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/categoria/:slug" element={<Category />} />
            <Route path="/categoria/:catSlug/:subSlug" element={<Items />} />
            <Route path="/qr" element={<QrPage />} />
            <Route path="/stampa" element={<PrintPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </div>
  );
}

export default App;
